'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../i-bem/i-bem.react');

var _bPointerfocus = (require('./../pointerfocus/pointerfocus.react.js').default || require('./../pointerfocus/pointerfocus.react.js')).applyDecls();

var _bPointerfocus2 = _interopRequireDefault(_bPointerfocus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'b-page',
    mix: function mix() {
        return { block: 'b-page', elem: 'body' };
    },
    content: function content() {
        return [_react2.default.createElement(_bPointerfocus2.default, { key: 'pointerfocus' }), this.props.children];
    }
});